import { render, staticRenderFns } from "./CBtnSave.vue?vue&type=template&id=2dae9fa7&"
import script from "./CBtnSave.vue?vue&type=script&lang=js&"
export * from "./CBtnSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports